import { children, createSignal, JSXElement, Show } from "solid-js"
import styles from './st-menu.module.css';
import Dropdown from "../st-dropdown/st-dropdown";

export class STMenuProps {
    children: JSXElement;
    label!: string;
}

export default function Menu(props: STMenuProps) {
    const content = children(() => props.children)

    return <>
        <Dropdown>
            <Dropdown.Trigger class={styles["st-menu-label"]} role="button">
                <span style="margin-right: 5px">{props.label}</span>
                <i class="fas fa-caret-down"></i>
            </Dropdown.Trigger>
            <Dropdown.Content>
                <ul class={styles['st-menu']}>
                    {content()}
                </ul>
            </Dropdown.Content>
        </Dropdown>
    </>
}

Menu.defaultProps = new STMenuProps();

export class STMenuItemProps {
    children?: JSXElement;
    label!: string;
    value?: string;
}

Menu.Item = (props: STMenuItemProps) => {
    const content = children(() => props.children)
    const value = props.value || props.label;

    return <li data-value={value}>
        <span>{props.label}</span>
        {content()}
    </li>
}
